import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

const getSankeyChartDataApi = ({ request1, request2 }) => {
  const url = endpoints.analytics.review.sankeyChart;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      request1,
      request2,
    },
  });
};

export default getSankeyChartDataApi;
